// extracted by mini-css-extract-plugin
export default {"pure":"pure__3d4528a4","studio_editor_input":"studio_editor_input__3d4528a4","error":"error__3d4528a4","stock_option":"stock_option__3d4528a4"};